var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo90(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260.294,
    height: 95,
    viewBox: "0 0 260.294 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1819",
    x: 0,
    y: 0,
    width: 260.294,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RSAndrews_logo_rgb",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RS_ANDREWS_LOGO_RGB",
    "data-name": "RS ANDREWS_LOGO_RGB",
    transform: "translate(-21.346 -26.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.35, 20.64)",
    filter: "url(#Path_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1819-2",
    "data-name": "Path 1819",
    d: "M164.708,34.858v-.392c0-1.35,0-1.771,0-1.9v-5.7a.234.234,0,0,0-.234-.234H63.773a.234.234,0,0,0-.234.234s0,6.19,0,7.592v.411H30.013a.239.239,0,0,0-.229.182l-.449,2.014L21.351,73.005a.231.231,0,0,0,.229.28h51.5a.229.229,0,0,1,.2.112c.86,1.416,1.766,2.789,2.71,4.1A69.728,69.728,0,0,0,110.8,102.584l2.476.776.771.243a.239.239,0,0,0,.14,0l.771-.243,2.476-.776a67.079,67.079,0,0,0,7.1-2.714.233.233,0,0,1,.327.2,3.79,3.79,0,0,0,2.752,3.569h7.648a.469.469,0,0,0,.467-.467V94.525a.234.234,0,0,0-.234-.234h-.8a67.9,67.9,0,0,0,11.428-9.466.228.228,0,0,1,.388.21l-.285,1.243-2.668,11.549a.232.232,0,0,0,.224.285h106.27a.23.23,0,0,0,.224-.178l1.5-6.415a.232.232,0,0,0-.224-.285h-1.7a.23.23,0,0,1-.224-.285l1.509-6.56a.232.232,0,0,0-.224-.285H240.484l1.911-8.232h0a3.887,3.887,0,0,0-1-2.542h13.568a.239.239,0,0,0,.229-.182l7.742-34.867.7-3.13a.231.231,0,0,0-.229-.28Z",
    transform: "translate(-12.35 -20.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5745",
    "data-name": "Group 5745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5741",
    "data-name": "Group 5741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5740",
    "data-name": "Group 5740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M129.374,98.066c0-.392-.14-.663-.579-.663a.554.554,0,0,0-.617.607c0,1.051,1.766.425,1.766,1.794a1.052,1.052,0,0,1-1.163,1.112c-.874,0-1.131-.449-1.131-1.247h.463c0,.42.028.869.7.869a.628.628,0,0,0,.649-.659c0-1.061-1.766-.444-1.766-1.817a.981.981,0,0,1,1.1-1.033.923.923,0,0,1,1.047,1.042h-.467Z",
    fill: "#003595"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M132.289,97.094l-.617,2.967h0l-.617-2.967h-.635v3.742h.378v-3.27h.009l.677,3.27h.378l.677-3.27h.009v3.27h.378V97.094Z",
    fill: "#003595"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M244.717,37.68h5.807l-7.3,32.854h-5.8Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M252.463,37.68h3.868l-7.3,32.854h-3.868Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M258.271,37.68l-7.3,32.854h1.934l7.3-32.854Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M40.245,70.482H34.452l7.288-32.8h5.789Z",
    fill: "#ee282f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M32.513,70.482H28.654l7.284-32.8H39.8Z",
    fill: "#ee282f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M49.486,37.68,42.2,70.482H82.845l7.33-32.8Z",
    fill: "#ee282f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M161.905,32.55V29.439H66.343V32.55c0,.023,0,.36,0,1.911,0,.78,0,1.888,0,3.462.028,6.452,1.079,22.879,11.928,37.932a66.525,66.525,0,0,0,33.382,24.052l2.472.776,2.472-.776a66.524,66.524,0,0,0,33.386-24.061c10.844-15.044,11.9-31.471,11.923-37.928V34.456c0-1.546,0-1.855,0-1.906",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M158.794,32.55H69.455c0,.131-.009.659,0,5.364.014,6.125,1.07,21.907,11.339,36.124a63.465,63.465,0,0,0,31.789,22.907l1.542.486,1.542-.486a63.415,63.415,0,0,0,31.789-22.907c10.269-14.217,11.32-30,11.339-36.124.014-4.7,0-5.228,0-5.364",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M82.639,74.468c-10.1-13.979-11.157-29.5-11.148-35.526V34.6h86.162V33.578H70.473v4.345c-.014,6.027,1.047,21.552,11.143,35.526a58.277,58.277,0,0,0,6.7,7.774,59.722,59.722,0,0,1-5.672-6.756",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M153.8,38.044h-1.047c0,.673,0,1.757,0,3.532-.009,5.3-.925,18.945-9.8,31.237a54.882,54.882,0,0,1-27.49,19.8l-1.336.42-1.332-.42A55.686,55.686,0,0,1,89.923,78.35a55.41,55.41,0,0,0,23.912,15.371l1.332.42,1.336-.42a54.882,54.882,0,0,0,27.49-19.8c8.882-12.292,9.793-25.939,9.8-31.237.019-4.065,0-4.518,0-4.635",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M242.811,37.68l-121.987-.028-6.76,5.522V48.1a4.543,4.543,0,0,0,0,7.905V92.021h0a.366.366,0,0,0,.065-.023l0,.023,1.285-.4a52.852,52.852,0,0,0,26.486-19.085q.715-1,1.36-1.995H235.5Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M114.063,43.17l6.76-5.522H74.557v.28c-.014,6.279,1.21,20.422,10.367,33.1a58.051,58.051,0,0,0,29.14,20.992s5.382-11.624,5.382-17.581-5.382-31.27-5.382-31.27",
    fill: "#ee282f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M94.973,53.177h-5.99V48.622h5.99a2.278,2.278,0,0,1,0,4.555m14.016,20.436a21.866,21.866,0,0,1-5.036-4.359,28.926,28.926,0,0,1-4.3-7.62c-.449-1.126-.771-2.1-.99-2.813a8.74,8.74,0,0,0-3.691-16.665h-5.99v0H82.508V63.213h6.471V59.657h3.186a38.771,38.771,0,0,0,6.788,13.726,24.156,24.156,0,0,0,4.294,3.948Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M98.515,51.537a2.912,2.912,0,0,0-1.205-2.355,2.873,2.873,0,0,1,.57,1.715,2.917,2.917,0,0,1-2.906,2.915h-5.99v.635h6.625a2.907,2.907,0,0,0,2.906-2.911",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M100.089,73.6c-4.308-5.27-5.924-11.713-6.4-13.479l-.131-.472h-.729a38.017,38.017,0,0,0,6.625,13.315A19.29,19.29,0,0,0,101.425,75a18.869,18.869,0,0,1-1.336-1.4",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M83.788,43.417h5.2v.009h6.625a8.054,8.054,0,0,1,5.378,2.084,8.069,8.069,0,0,0-6.018-2.724h-6.62v0h-5.2V62.573h.635V43.417Z",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M133.831,55.294a28.671,28.671,0,0,1,2.126-4.163c.589-.962,1.168-1.813,1.682-2.514h1.219v6.676h-5.027Zm11.5,9.316V42.147h-17.7v6.471h2.3a27.954,27.954,0,0,0-4.023,12.442c-.019.318-.023.635-.023.953a35.108,35.108,0,0,0,1.817,9.419l5.667-3.677a17.8,17.8,0,0,1-1.018-5.742c0-.079.009-.159.009-1.621h6.489V64.61h6.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M140.059,62.4V60.386h-.64l0,3.64h.645Z",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M128.9,43.422h15.782v-.64H128.262v5.2h.64Z",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M140.129,48.617h-.64v7.312h-5.7l-.266.635h6.611Z",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M127.159,62.643c0-.313,0-.617.023-.916a27.358,27.358,0,0,1,3.939-12.161l.551-.948h-1l-.182.313a27.338,27.338,0,0,0-3.939,12.157c-.014.3-.019.6-.019.916a33.756,33.756,0,0,0,1.532,8.433l.378-.248a31.71,31.71,0,0,1-1.28-7.545",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M123.982,45.333V37.474l-3.182-.635v.719c-5.1.575-12.189,2.817-13.932,10.834-1.289,5.929,2.042,10.863,5,15.9,2.883,4.92,4.532,10.092,2.215,14.3-3.611,6.56-12.516,8.769-12.516,8.769l1.047.425s7.714,3.495,9.69,4.233c1.28,1,.939.3,1.145.224,5.8-1.976,11.208-8.19,11.442-16.871.178-6.686-2.233-11.722-7.008-18.786-3.107-4.6-3.112-10.76,6.1-11.255",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M115.283,79.532a9.772,9.772,0,0,0,1.168-4.737c0-2.822-1.346-5.751-2.836-8.606a18.43,18.43,0,0,1,2.2,7.971,9.79,9.79,0,0,1-1.173,4.737c-2.593,4.653-7.555,7.139-10.521,8.284.327.178.645.336.962.509,2.985-1.187,7.69-3.649,10.2-8.157",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M122.076,38.437h-2.859c-4.737.86-10.25,3.28-11.732,10.092a11.335,11.335,0,0,0-.271,2.5c-.009,3.35,1.453,6.471,3.238,9.606a18.257,18.257,0,0,1-2.6-8.966,11.646,11.646,0,0,1,.28-2.5c1.649-7.629,8.924-10.143,13.946-10.732",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M223.782,45.973a1.254,1.254,0,0,1,1.266-1.378c.785,0,1.159.762,1.159,1.682v.369h3.8c0-3.345-1.509-4.808-5.046-4.808-3.434,0-5.116,1.724-5.116,4.878,0,5.527,6.382,4,6.382,7.083a1.346,1.346,0,0,1-1.313,1.509c-.79,0-1.332-.481-1.332-1.813v-.369h-3.934v.547c0,3.233,1.878,4.392,5.247,4.392,3.583,0,5.532-1.486,5.532-4.808,0-5.709-6.648-4.2-6.648-7.284M213.27,52.944h-.042l-1.6-10.8h-3.668l-1.467,10.8h-.042l-1.224-10.8H201.3l2.668,15.6h4.457l1.355-10.493h.042l1.355,10.493h4.462l2.663-15.6h-3.934Zm-19.015-1.617h4.85V48.136h-4.85V45.468h5.181V42.147H190.19v15.6h9.442V54.429h-5.378Zm-12.965-2.579h-.808V45.076h.79c1.224,0,1.729.547,1.729,1.817,0,1.112-.551,1.855-1.71,1.855m5.854,8.307a6.4,6.4,0,0,1-.2-2.163V53.56c0-2.074-.589-3.322-2.56-3.495v-.042c1.855-.285,2.668-1.64,2.668-3.714,0-2.4-1.182-4.153-4.284-4.153h-6.359v15.6h4.065V51.509h1.07c.986,0,1.336.458,1.336,2.229v1.051a8.215,8.215,0,0,0,.392,2.971H187.6v-.22a1.178,1.178,0,0,1-.458-.486m-19.655-2.229h-.808V45.076h.808c1.574,0,1.771.659,1.771,4.873s-.2,4.878-1.771,4.878m1.028-12.68h-5.9v15.6h5.9c4.7,0,4.943-3.714,4.943-7.8s-.243-7.8-4.943-7.8m-12.932,9.615h-.042l-2.621-9.615h-4.546v15.6h3.8V48.113h.047l2.71,9.638h4.457v-15.6h-3.8v9.615Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M185.91,43.763a3.781,3.781,0,0,0-3.14-1.205h-5.948V57.34h.411V42.969h5.952a4.17,4.17,0,0,1,2.724.794m-2.1,3.537a2.084,2.084,0,0,0-.794-1.888,2.519,2.519,0,0,1,.383,1.476,2.017,2.017,0,0,1-2.116,2.266h-.808v.411H181.7a2.013,2.013,0,0,0,2.116-2.266m-15.3-4.742h-5.49V57.34h.411V42.969h5.49a4.44,4.44,0,0,1,2.911.841,4.041,4.041,0,0,0-3.322-1.252m-15.577,5.555h-.294l2.593,9.227h.294l-2.509-8.928Zm57.648-.85h-.36l1.3,10.082h.36l-1.257-9.723Zm-57.985-4.7h-3.822V57.34h.411V42.969h3.523ZM223.2,53.943a3.752,3.752,0,0,1-.023-.411h-3.112v.135a3.652,3.652,0,0,0,1.177,3.06,4.029,4.029,0,0,1-.766-2.654v-.135H223.2Zm-39.493.2c0-1.173-.154-2.023-.78-2.411a3.86,3.86,0,0,1,.369,2V54.78a9.309,9.309,0,0,0,.262,2.56h.308a11.531,11.531,0,0,1-.154-2.149V54.14Zm15.32-11.582H190.6V57.34h.411V42.969h8.013Zm5.835,0h-3.079l2.528,14.782h.341l-2.458-14.371h2.719Zm-20.468,7.914v.369l.374.033a2.577,2.577,0,0,1,1.275.411,2.124,2.124,0,0,0-1.649-.813m41.843-5.644a2.545,2.545,0,0,1,.383,1.411H227a1.892,1.892,0,0,0-.762-1.411m-12.558,8.157-.037.374h-.42l.009.056.051.35h.766l.037-.369,1.051-10.428h2.6l.07-.411h-3.074Zm12.516-.514a2.062,2.062,0,0,1,.444,1.327,1.75,1.75,0,0,1-1.719,1.92,1.7,1.7,0,0,1-.953-.266,1.568,1.568,0,0,0,1.364.673,1.751,1.751,0,0,0,1.724-1.92,2.1,2.1,0,0,0-.86-1.733m-1.972-4.789a5.779,5.779,0,0,0,2.387,1.425,8.716,8.716,0,0,1,2.5,1.341A7.168,7.168,0,0,0,226.2,48.7a8.023,8.023,0,0,1-1.976-1.014m-2.7,2.135a3.959,3.959,0,0,1-.86-2.691c0-2.962,1.584-4.466,4.7-4.466a5.285,5.285,0,0,1,3.383.883c-.729-.892-1.953-1.294-3.794-1.294-3.121,0-4.7,1.5-4.7,4.466a3.81,3.81,0,0,0,1.271,3.1m-65.53,2.359h-.467l.028.107.084.3h.771v-9.62h2.57v-.411H156v9.62Zm38.259,3.074h4.966V54.84h-4.966Zm-25.117-9.9c.491.748.533,2.168.533,4.6,0,4.013-.1,5.284-2.182,5.284h-.813v.411h1.219c2.084,0,2.182-1.271,2.182-5.284,0-2.985-.051-4.452-.939-5.008m42.137-2.794h-2.957L206.9,53l-.047.36h-.406l0,.047.037.364h.771l.047-.355,1.416-10.442h2.612Zm-12.582,5.99h-4.438v.411h4.438Z",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M149.875,63.045c0,.472.406.757,1.6.757s1.6-.285,1.6-.757V61.078c0-.472-.406-.757-1.6-.757s-1.6.285-1.6.757Zm4.812.051c0,.832-.813,1.537-3.21,1.537s-3.205-.705-3.205-1.537v-2.07c0-.832.813-1.537,3.205-1.537s3.21.705,3.21,1.537Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M156.406,64.558V59.564h5.242V60.4h-3.64v1.327h3.359v.836h-3.359v2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M167.451,60.4h-2.364v-.832h6.335V60.4h-2.364v4.163h-1.607Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 1.603,
    height: 4.994,
    transform: "translate(172.758 59.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5742",
    "data-name": "Group 5742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M177.94,63.727h1.388c1.084,0,1.374-.257,1.374-.734V61.134c0-.481-.294-.734-1.374-.734H177.94Zm1.556-4.163c2.088,0,2.813.621,2.813,1.341v2.313c0,.71-.724,1.341-2.813,1.341h-3.158V59.564H179.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M184.023,59.564h5.2V60.4H185.63v1.21h3.308v.832H185.63v1.289h3.588v.832h-5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M198.6,63.432l1.617-3.868H201.8l-2.1,4.994h-2.163l-1.556-4.018-1.551,4.018h-2.163l-2.1-4.994h1.593l1.617,3.868,1.537-3.868h2.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M204.351,62.708h2.341l-1.159-2.364Zm2.752.818h-3.144l-.533,1.037h-1.682l2.672-4.994h2.238l2.672,4.994h-1.682Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M211.546,60.4h-2.369v-.832h6.335V60.4h-2.364v4.163h-1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M216.788,59.564h5.191V60.4H218.39v1.21H221.7v.832H218.39v1.289h3.588v.832h-5.191Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5743",
    "data-name": "Group 5743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M227.047,60.4h-1.808v1.7h1.808c.878,0,1.159-.187,1.159-.607v-.5c0-.42-.308-.593-1.159-.593m1.668,4.163-1.948-1.649h-1.528v1.649h-1.6V59.564h3.476c1.972,0,2.7.472,2.7,1.35v.654c0,.6-.383,1.019-1.271,1.21l2.1,1.785h-1.92Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5744",
    "data-name": "Group 5744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M163.8,83.242h-1.546l.883-3.845h-1.416l-.883,3.845h-1.546l1.939-8.405h1.546l-.762,3.3h1.416l.762-3.3h1.546Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M170.824,76.108H168.3l-.453,1.976h2.383l-.3,1.275h-2.383l-.593,2.584H169.6l-.3,1.3H165.11l1.939-8.405h4.069Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M174.931,74.837c-.061,1.738-.224,8.405-.224,8.405h-1.523l.093-1.369h-1.43l-.523,1.369h-1.6l3.429-8.405Zm-1.546,5.737.262-3.607-1.332,3.607Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M180.766,76.047h-1.56l-1.668,7.195h-1.56l1.668-7.19H176.1l.276-1.215h4.667Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M181.383,83.242h-1.537l1.939-8.405h1.537Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M187.443,83.242H185.49c0-1.047-.037-6.3-.037-6.3l-1.322,6.3h-1.453l1.939-8.405h1.99c.014,1.061.084,6.167.084,6.167l1.275-6.167h1.416Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M193.072,77.551l.178-.808a1.73,1.73,0,0,0,.047-.322c0-.355-.224-.547-.668-.547-.537,0-.752.252-.939,1.084l-.962,4.191a2.447,2.447,0,0,0-.084.514c0,.346.252.561.645.561.5,0,.776-.276.93-.962l.3-1.308h-.953l.3-1.261h2.495l-1.061,4.56h-1.322l.117-.5a1.955,1.955,0,0,1-1.56.677,1.31,1.31,0,0,1-1.5-1.369,4.376,4.376,0,0,1,.117-.93l.976-4.2c.392-1.668,1.093-2.261,2.7-2.261,1.369,0,2.1.453,2.1,1.308a2.964,2.964,0,0,1-.107.668l-.215.916h-1.528Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M198.632,83.242h-1.093l1.939-8.405h1.107Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M207.023,77.892l.192-.855a3.053,3.053,0,0,0,.107-.607c0-.369-.178-.584-.645-.584-.5,0-.752.262-.906.916l-1.023,4.406a2.854,2.854,0,0,0-.07.514c0,.346.224.537.645.537.537,0,.762-.238.939-1.037l.252-1.093h1.523l-.224,1.014c-.406,1.845-1.084,2.322-2.654,2.322-1.523,0-2.06-.57-2.06-1.514a4.3,4.3,0,0,1,.131-.878l.962-4.144c.383-1.621,1.117-2.229,2.724-2.229,1.3,0,1.99.463,1.99,1.346a4.02,4.02,0,0,1-.117.855l-.238,1.037h-1.528Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M213.335,81.191c-.285,1.238-.776,2.224-2.57,2.224-1.416,0-2.13-.561-2.13-1.645a4.2,4.2,0,0,1,.145-1l.892-3.836c.383-1.645,1-2.3,2.57-2.3,1.383,0,2.154.584,2.154,1.631a4.108,4.108,0,0,1-.117.822ZM212.751,77a1.95,1.95,0,0,0,.084-.584c0-.383-.252-.593-.668-.593-.514,0-.724.168-.939,1.107l-.93,4.023a3.194,3.194,0,0,0-.117.668c0,.383.252.584.7.584.654,0,.762-.439.916-1.107Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M219.156,81.191c-.285,1.238-.776,2.224-2.57,2.224-1.416,0-2.13-.561-2.13-1.645a4.2,4.2,0,0,1,.145-1l.892-3.836c.383-1.645,1-2.3,2.57-2.3,1.383,0,2.154.584,2.154,1.631a4.108,4.108,0,0,1-.117.822ZM218.572,77a1.95,1.95,0,0,0,.084-.584c0-.383-.252-.593-.668-.593-.514,0-.724.168-.939,1.107l-.93,4.023a3.194,3.194,0,0,0-.117.668c0,.383.252.584.7.584.654,0,.762-.439.916-1.107Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M223.749,83.242h-3.822l1.939-8.405h1.546l-1.645,7.13h2.275Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M226.048,83.242H224.51l1.939-8.405h1.537Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M232.107,83.242h-1.953c0-1.047-.037-6.3-.037-6.3l-1.322,6.3h-1.453l1.939-8.405h1.99c.014,1.061.084,6.167.084,6.167l1.275-6.167h1.416Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M237.737,77.551l.178-.808a1.73,1.73,0,0,0,.047-.322c0-.355-.224-.547-.668-.547-.537,0-.752.252-.939,1.084l-.962,4.191a2.446,2.446,0,0,0-.084.514c0,.346.252.561.645.561.5,0,.776-.276.93-.962l.3-1.308h-.953l.3-1.261h2.5l-1.061,4.56h-1.322l.117-.5a1.955,1.955,0,0,1-1.56.677,1.31,1.31,0,0,1-1.5-1.369,4.377,4.377,0,0,1,.117-.93l.976-4.2c.392-1.668,1.093-2.261,2.7-2.261,1.369,0,2.1.453,2.1,1.308a2.966,2.966,0,0,1-.107.668l-.215.916h-1.532Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M151.655,86.914c.832,0,1.453.406,1.453,1.271a4.24,4.24,0,0,1-.093.762l-.271,1.2c-.276,1.191-.715,1.668-2.046,1.668h-1.308l-.808,3.5h-1.56l1.939-8.4h2.7Zm-2,3.7h.748c.593,0,.738-.117.878-.748l.192-.855a2.02,2.02,0,0,0,.061-.392c0-.332-.168-.463-.631-.463h-.677Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M156.387,95.314H152.57l1.939-8.4h1.546l-1.64,7.125h2.271Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M161.7,93.422a2.331,2.331,0,0,1-2.57,2.07c-1.308,0-2.009-.561-2.009-1.607a4.1,4.1,0,0,1,.154-.962l1.378-6.008H160.2L158.8,93.006a3.9,3.9,0,0,0-.107.607c0,.355.238.561.654.561.463,0,.677-.252.855-1.023l1.439-6.233h1.56Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M169.558,95.314h-1.546l1.822-7.284L166.8,95.314h-1.439l.285-7.284-1.56,7.284h-1.523l1.939-8.4h2.523l-.369,5.877,2.355-5.877H171.5Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M175.183,86.914c.906,0,1.761.117,1.761,1.247a2.634,2.634,0,0,1-.07.593l-.117.537c-.224,1.037-.514,1.346-1.322,1.5.523.117.785.392.785.822a5.083,5.083,0,0,1-.117.892l-.238,1.07a1.925,1.925,0,0,1-2.154,1.738h-2.845l1.939-8.4ZM172.688,94.1h.547c.785,0,1-.037,1.177-.846l.224-.986a2.645,2.645,0,0,0,.047-.369c0-.332-.192-.453-.715-.453H173.3Zm.9-3.868h.416c.808,0,1.047-.145,1.177-.776l.107-.5a2.2,2.2,0,0,0,.061-.378c0-.332-.192-.463-.654-.463h-.617Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M178.206,95.314h-1.537l1.939-8.4h1.537Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M184.261,95.314h-1.953c0-1.047-.037-6.293-.037-6.293l-1.322,6.293H179.5l1.939-8.4h1.986c.014,1.061.084,6.162.084,6.162l1.275-6.162H186.2Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M189.891,89.629l.178-.808a1.73,1.73,0,0,0,.047-.322c0-.355-.224-.547-.668-.547-.537,0-.748.248-.939,1.084l-.962,4.186a2.446,2.446,0,0,0-.084.514c0,.346.252.561.645.561.5,0,.776-.276.93-.962l.3-1.308h-.953l.3-1.261h2.5l-1.061,4.555H188.8l.117-.5a1.955,1.955,0,0,1-1.56.677,1.31,1.31,0,0,1-1.5-1.369,4.376,4.376,0,0,1,.117-.93l.976-4.2c.392-1.668,1.093-2.261,2.7-2.261,1.369,0,2.093.453,2.093,1.308a2.964,2.964,0,0,1-.107.668l-.215.916h-1.528Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M195.446,95.314h-1.093l1.939-8.4H197.4Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M205.234,88.185h-2.523l-.453,1.976h2.378l-.3,1.275h-2.378l-.593,2.584H204l-.3,1.3H199.52l1.939-8.4h4.069Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M208.425,95.314h-3.817l1.939-8.4h1.546l-1.64,7.125h2.271Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M214.9,88.185h-2.523l-.453,1.976H214.3l-.3,1.275H211.62l-.593,2.584h2.64l-.3,1.3h-4.186l1.939-8.4h4.069Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M218.572,89.97l.192-.855a3.053,3.053,0,0,0,.107-.607c0-.369-.178-.584-.645-.584-.5,0-.748.262-.906.916l-1.023,4.4a2.854,2.854,0,0,0-.07.514c0,.346.224.537.645.537.537,0,.762-.238.939-1.037l.252-1.093h1.523l-.224,1.014c-.406,1.845-1.084,2.322-2.654,2.322-1.523,0-2.06-.57-2.06-1.509a4.3,4.3,0,0,1,.131-.878l.962-4.139a2.411,2.411,0,0,1,2.724-2.224c1.3,0,1.986.463,1.986,1.346a4.021,4.021,0,0,1-.117.855l-.238,1.037h-1.523Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M225.576,88.129h-1.56l-1.668,7.186h-1.56l1.668-7.186h-1.546l.276-1.215h4.663Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M229.253,86.914c1.168,0,1.584.537,1.584,1.332a2.121,2.121,0,0,1-.061.523l-.192.822c-.215.93-.561,1.285-1.416,1.43.607.168.846.439.846.986a3.214,3.214,0,0,1-.093.724l-.332,1.462a4.541,4.541,0,0,0-.084.607.59.59,0,0,0,.178.509h-1.7a1.231,1.231,0,0,1-.084-.439,2.268,2.268,0,0,1,.07-.509l.369-1.56a2.55,2.55,0,0,0,.117-.668c0-.369-.215-.523-.748-.523h-.645l-.855,3.7H224.66l1.939-8.4h2.654Zm-1.294,3.5c.785,0,.93-.117,1.131-.986l.145-.617a.929.929,0,0,0,.037-.238c0-.322-.192-.453-.677-.453h-.715l-.537,2.3h.617Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M232.014,95.314h-1.537l1.939-8.4h1.537Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M237.616,89.97l.192-.855a3.053,3.053,0,0,0,.107-.607c0-.369-.178-.584-.645-.584-.5,0-.748.262-.906.916l-1.023,4.4a2.854,2.854,0,0,0-.07.514c0,.346.224.537.645.537.537,0,.762-.238.939-1.037l.252-1.093h1.523l-.224,1.014C238,95.02,237.321,95.5,235.751,95.5c-1.523,0-2.06-.57-2.06-1.509a4.3,4.3,0,0,1,.131-.878l.962-4.139a2.411,2.411,0,0,1,2.724-2.224c1.3,0,1.986.463,1.986,1.346a4.021,4.021,0,0,1-.117.855l-.238,1.037h-1.523Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M243.61,86.914c-.061,1.738-.224,8.4-.224,8.4h-1.523l.093-1.369h-1.43L240,95.314H238.41l3.425-8.4Zm-1.546,5.733.262-3.607-1.332,3.607Z",
    fill: "#003595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M248.016,95.314H244.2l1.939-8.4h1.546l-1.64,7.125h2.271Z",
    fill: "#003595"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M32.078,37.68l-7.288,32.8h1.93L34,37.68Z",
    fill: "#ee282f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo90);
export default __webpack_public_path__ + "static/media/logo_90.1d89a0a19f087083bf8dd8568858e2ae.svg";
export { ForwardRef as ReactComponent };